import React, { useEffect, useState } from "react";
import axios from "axios";
import { Flex, Button } from "@chakra-ui/react";
import { TailSpin } from "react-loader-spinner";

import HistoryItem from "views/admin/prodPlusVendus/components/HistoryItem";
import Card from "components/card/Card.js";
import defaultImage from "assets/img/meds.png";
import { API_URL, CURRENCY } from "../../constants";
import { getAuthToken } from "../../helpers/helpers";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function WithoutDatePeremption() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const token = getAuthToken();
      try {
        const response = await axios.get(`${API_URL}/api/inventory`, {
          headers: {
            "x-access-token": token,
            Authorization: `Bearer ${token}`,
          },
        });
        const filteredItems = response.data.filter(item => item.date_peremption === null);
        setItems(filteredItems);
      } catch (error) {
        console.error("Error making the request:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(18);
    doc.text("Liste des Produits Sans Date de Péremption", 14, 22);
    const tableColumn = [
      "Nom",
      "Forme",
      // "Prix",
      "Quantité en stock"
    ];
    const tableRows = [];
    items.forEach((item) => {
      const productData = [
        item.specialite,
        item.forme,
        // item.prix,
        item.qte_stock
      ];
      tableRows.push(productData);
    });
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
    });
    doc.save("produits_sans_date_peremption.pdf");
  };
  
  

  return (
    <Flex
      flexDirection="column"
      py="100px"
      justifyContent={isLoading ? "center" : "flex-start"}
      alignItems={isLoading ? "center" : "stretch"}
      minHeight={isLoading ? "400px" : "auto"}
    >
      {isLoading ? (
        <div style={{ textAlign: "center" }}>
          <TailSpin
            height="120"
            width="120"
            color="#17254C"
            ariaLabel="tail-spin-loading"
            radius="1"
            visible
          />
          <p style={{ marginTop: "20px", color: "#17254C", fontSize: "16px" }}>
            Chargement des données
          </p>
        </div>
      ) : (
        <>
          {items.length > 0 && (
            <Flex justifyContent="flex-end" mb="20px">
              <Button onClick={generatePDF} colorScheme="teal" width="200px">
                Télécharger en PDF
              </Button>
            </Flex>
          )}
          <Card p="0px">
            <div>
              {items.length > 0 ? (
                items.map((item, index) => (
                  <Flex key={index} alignItems="center" mb="10px">
                    <HistoryItem
                      name={item.specialite}
                      image={item.photo || defaultImage}
                      price={item.prix}
                      forme={item.forme}
                      id={item.med_id}
                      text={CURRENCY.code}
                    />
                  </Flex>
                ))
              ) : (
                <p>Aucun élément à afficher</p>
              )}
            </div>
          </Card>
        </>
      )}
    </Flex>
  );
}
